import { render, staticRenderFns } from "./EditorBanner.vue?vue&type=template&id=b7c3c8a0&"
import script from "./EditorBanner.vue?vue&type=script&lang=js&"
export * from "./EditorBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports